// recursively check an object containing objects for all keys to match the input val.
export const checkRecursiveByVal = (obj: object, val: unknown) => {
  return Object.values(obj).some((value) => {
    if (typeof value === 'object') {
      if (!checkRecursiveByVal(value, val)) {
        return false;
      }
    } else if (value !== val) {
      return false;
    }

    return true;
  });
};

// recursively set the keys of an object containing objects --and those objects keys, recursively--...
// ...for all keys to match the input val.
export const setRecursiveByVal = (obj: object, val: unknown) => {
  const tempObj: Record<string, unknown> = { ...obj };
  Object.entries(tempObj).forEach(([key, value]) => {
    if (typeof value === 'object' && value != null) {
      tempObj[key] = setRecursiveByVal(value, val);
    } else {
      tempObj[key] = val;
    }
  });
  return tempObj;
};
